import { REWARD_CENTER_CATEGORY_ICON_TYPE } from '../constants';
var getRewardCenterCategoryMenuIcon = function getRewardCenterCategoryMenuIcon(_ref) {
  var _rewardCenterAssets$R, _rewardCenterAssets$R2;
  var categoryIconType = _ref.categoryIconType,
    rewardCenterAssets = _ref.rewardCenterAssets;
  switch (categoryIconType) {
    case REWARD_CENTER_CATEGORY_ICON_TYPE.REDEEM_COINS:
      return (_rewardCenterAssets$R = rewardCenterAssets === null || rewardCenterAssets === void 0 ? void 0 : rewardCenterAssets.REWARD_CENTER_USE_COINS_CATEGORY) !== null && _rewardCenterAssets$R !== void 0 ? _rewardCenterAssets$R : null;
    case REWARD_CENTER_CATEGORY_ICON_TYPE.REDEEM_LOYALTY:
      return (_rewardCenterAssets$R2 = rewardCenterAssets === null || rewardCenterAssets === void 0 ? void 0 : rewardCenterAssets.REWARD_CENTER_USE_LOYALTY_POINTS_CATEGORY) !== null && _rewardCenterAssets$R2 !== void 0 ? _rewardCenterAssets$R2 : null;
    default:
      return null;
  }
};
export default getRewardCenterCategoryMenuIcon;